import { createSlice } from "@reduxjs/toolkit";

interface IWheel {
  lastWinningNumber: number;
  winningNumber: number;
}

const initialState: IWheel = {
  lastWinningNumber: 5,
  winningNumber: 5,
};

export const wheelSlice = createSlice({
  name: "wheel",
  initialState,
  reducers: {
    setWinningNumber: (state, { payload }) => {
      state.lastWinningNumber = state.winningNumber;
      state.winningNumber = payload;
    },
    setLastWinningNumber: (state) => {
      state.lastWinningNumber = state.winningNumber;
    },
  },
});

export const { setWinningNumber, setLastWinningNumber } = wheelSlice.actions;

export default wheelSlice.reducer;
